module.exports = __webpack_public_path__ + "img/206778.2bf60e5d.png";